export default "__VITE_ASSET__2fc3770c__"